var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89844 0H4.10156C1.83633 0 0 1.83633 0 4.10156V9.89844C0 12.1637 1.83633 14 4.10156 14H9.89844C12.1637 14 14 12.1637 14 9.89844V4.10156C14 1.83633 12.1637 0 9.89844 0Z",
    fill: "url(#paint0_linear_31871_14368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2812 6.31641H7.68359V3.71875C7.68359 3.34113 7.37762 3.03516 7 3.03516C6.62238 3.03516 6.31641 3.34113 6.31641 3.71875V6.31641H3.71875C3.34113 6.31641 3.03516 6.62238 3.03516 7C3.03516 7.37762 3.34113 7.68359 3.71875 7.68359H6.31641V10.2812C6.31641 10.6589 6.62238 10.9648 7 10.9648C7.37762 10.9648 7.68359 10.6589 7.68359 10.2812V7.68359H10.2812C10.6589 7.68359 10.9648 7.37762 10.9648 7C10.9648 6.62238 10.6589 6.31641 10.2812 6.31641Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31871_14368",
    x1: 1.20121,
    y1: 1.20121,
    x2: 12.7988,
    y2: 12.7988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2492FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateList);
export default __webpack_public_path__ + "static/media/CreateList.49c177b252f8823b80d7677244020579.svg";
export { ForwardRef as ReactComponent };